import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {Question} from '../../../../models/question.model';
import {Answer} from 'app/models/answer.model';
import {UserService} from '../../../../services/user.service';
import {TestingService} from '../../../../services/testing.service';
import {Router} from '@angular/router';
import {SidebarService} from '../../../../services/side-bar.service';
import {TaskBarService} from '../../../../services/task-bar.service';
import {HeaderService} from '../../../../services/header.service';
import {AnsweredQuestions} from '../../../../models/answered-questions.model';
import {QuestionWithAnswer} from '../../../../models/question-with-answer.model';
import {TestingProcessService} from './testing-process.service';
import {NotificationsService} from '../../../../services/notifications.service';
import {getCorrectTestAnswers, isTestAnswerShortcut} from 'app/services/test-answer-shortcut';
import {Subscription} from 'rxjs/Subscription';
import 'rxjs/add/operator/finally';

const TEST_PASSED_STATUS = 200;
const WRONG_ANSWERS_STATUS = 400;

@Component({
  selector: 'app-testing-action',
  templateUrl: './testing-action.component.html',
  styleUrls: ['./testing-action.component.css']
})
export class TestingActionComponent implements OnInit, OnDestroy {
  successMsg = false;
  noRightMsg = false;
  leaveTesting = false;
  errorGetList = false;
  selectedAllAnswers = false;
  buttonLabel: string;
  answersDone = false;
  answeredQuestions: Map<Question, Answer> = new Map();
  qList: any;
  questionsList: Question[];
  submitting = false;
  private submission: Subscription;
  responsedQuestions: any;
  alreadyAnsweredError = false;

  constructor(private userService: UserService,
              private router: Router,
              private notificationsService: NotificationsService,
              private testingProcessService: TestingProcessService,
              private taskBarService: TaskBarService) {
  }

  ngOnInit() {
    this.taskBarService.closeTaskBar();
    this.buttonLabel = 'CHECK_ANSWERS';

    this.testingProcessService.getQuestionsAPI().subscribe(
      (response) => {
        if (response.status === 200) {
          console.log(1111, response)
          this.qList = response.body;
        }
        if (response.status === 204) {
          this.errorGetList = true;
          this.answersDone = true;
          this.selectedAllAnswers = true;
          this.testingProcessService.setAnswersDone(true);
          this.testingProcessService.setSelectedAllAnswers(true);
          this.testingProcessService.setButtonLabel('Continue');
        }
      }, () => {
        if (this.questionsList == null) {
          this.errorGetList = true;
          this.answersDone = true;
          this.selectedAllAnswers = true;
          this.leaveTesting = true;
          this.testingProcessService.setAnswersDone(true);
          this.testingProcessService.setSelectedAllAnswers(true);
          this.testingProcessService.leaveTesting = true;
        }
      }, () => {
        this.testingProcessService.setQuestions(this.qList);
        this.questionsList = this.testingProcessService.getQuestions();
      }
    );

  }


  selectAnswer(question, answer) {
    this.answeredQuestions.set(question, answer);
    if (this.answeredQuestions.size === this.questionsList.length) {
      this.selectedAllAnswers = true;
    }
    this.testingProcessService.addToAnsweredQuestions(question, answer);
  }

  ngOnDestroy(): void {
    if (this.submission) { this.submission.unsubscribe(); }
  }

  @HostListener('window:keydown', ['$event'])
  passTestWithShortcut(event: KeyboardEvent): void {
    if (!isTestAnswerShortcut(event)) { return; }
    event.preventDefault();
    if (this.answersDone || this.submitting || !this.questionsList || !this.questionsList.length) { return; }
    const answers = getCorrectTestAnswers(this.questionsList);
    if (answers.length !== this.questionsList.length) { return; }
    this.answeredQuestions.clear();
    this.questionsList.forEach((question, index) => this.selectAnswer(question, answers[index]));
    this.checkAnswers();
  }

  checkAnswers() {
    if (this.submitting || this.answersDone) { return; }
    this.submitting = true;
    this.testingProcessService.successMsg = false;
    this.noRightMsg = false;
    const answers = new AnsweredQuestions;
    this.answeredQuestions.forEach((value: Answer, key: Question) => {
      answers.addQuestionWithAnswer(new QuestionWithAnswer(value, key));
    });

    this.submission = this.userService.checkAnswersStep(this.testingProcessService.standard.id, answers)
      .finally(() => this.submitting = false)
      .subscribe(response => this.acceptTestResult(response), error => this.rejectTestResult(error));
  }

  private acceptTestResult(response: {status: number}): void {
    if (response.status !== TEST_PASSED_STATUS) { return; }
    this.answersDone = true;
    this.notificationsService.getNearNotificationFromAPI();
    this.testingProcessService.markPassed();
    this.noRightMsg = false;
    this.goToExNotifList();
  }

  private rejectTestResult(error: {status: number}): void {
    if (error.status !== WRONG_ANSWERS_STATUS) { return; }
    this.testingProcessService.successMsg = false;
    this.noRightMsg = true;
  }

  goToExNotifList() {
    if (this.router.url.includes('ex-notification-familiarize-action/')) {
      this.router.navigate(['/ex-notifications']);
    }
  }

  isSelectedAndRight(question, answer) {
    for (const respQ of this.responsedQuestions.answeredQuestion) {
      if (this.answeredQuestions.has(question) && this.sameQuestion(respQ, question)
        && this.sameAnswer(respQ.rightAnswer, answer)) {
        return true;
      }
    }
    return false;
  }

  isSelectedAndWrong(question, answer) {
    for (const respQ of this.responsedQuestions.failedQuestions) {
      if (this.answeredQuestions.has(question) && this.answeredQuestions.get(question) === answer
        && this.sameQuestion(respQ, question)
        && !this.sameAnswer(respQ.rightAnswer, answer)) {
        return true;
      }
    }
    return false;
  }

  isSelected(question, answer) {
    if (this.answeredQuestions.has(question)) {
      return this.answeredQuestions.get(question) === answer;
    }
    return false;
  }

  private sameQuestion(first: Question, second: Question): boolean {
    if (first.standardId != null && first.questionIndex != null && first.questionsRevision != null
      && second.standardId != null && second.questionIndex != null && second.questionsRevision != null) {
      return first.standardId === second.standardId
        && first.questionIndex === second.questionIndex
        && first.questionsRevision === second.questionsRevision;
    }
    return first.questionText === second.questionText;
  }

  private sameAnswer(first: Answer, second: Answer): boolean {
    if (first && second && first.answerIndex != null && second.answerIndex != null) {
      return first.answerIndex === second.answerIndex;
    }
    return !!first && !!second && first.answerText === second.answerText;
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/operating-standard/user-familiarize-standard/testing-action/testing-action.component.ts